import type { TourStop } from 'fym-shared/src/music24/onboardingTour';
import type { ReleaseListRow } from 'fym-shared/src/music24/releases';
import { SMLRootParamList, SMLRouteNames, SMLRouteParts, SMLRoutes } from '../../../routing/sml/SMLRoutes';
import type { CatalogItem } from '../../../redux/api/fymAPI.types';

export interface TourRoute {
  route: SMLRouteParts;
  params?: SMLRootParamList[SMLRouteNames];
}

/** The song of LaziiBee that the kit and plan stops show. */
const DEMO_SONG_TITLE = 'forests';

/**
 * The page of one tour stop. `demoSongUuid` is the LaziiBee song of the kit and plan stops.
 * An empty uuid (the demo catalog did not load) opens the Releases list instead.
 * Ruling R6: the plan stop opens the Plan tab of the release only.
 */
export function tourRoute(stop: TourStop, demoSongUuid: string): TourRoute {
  switch (stop) {
    case 'kit':
    case 'plan':
      if (demoSongUuid === '') {
        return { route: SMLRoutes.promote };
      }
      return {
        route: SMLRoutes.promoteRelease,
        params: { catalogItemUuid: demoSongUuid, tab: stop === 'kit' ? 'kit' : 'plan' },
      };
    case 'link':
      return { route: SMLRoutes.smartlinks };
    case 'numbers':
      return { route: SMLRoutes.streaming };
    case 'home':
      return { route: SMLRoutes.home };
    default:
      return { route: SMLRoutes.home };
  }
}

/**
 * The demo song of the tour: the catalog row titled "Forests", else the first upcoming release,
 * else the first catalog row. An empty string when the catalog has no row.
 */
export function pickDemoSongUuid(items: readonly CatalogItem[], rows: readonly ReleaseListRow[]): string {
  const forests = items.find((item) => item.title.trim().toLocaleLowerCase() === DEMO_SONG_TITLE);
  if (forests !== undefined) {
    return forests.uuid;
  }
  const upcoming = rows.find((row) => row.group === 'upcoming');
  if (upcoming !== undefined) {
    return upcoming.catalogItemUuid;
  }
  return items[0]?.uuid ?? '';
}
